import api from './api';

/**
 * @returns {Promise<{
 *  rubric_id: string
 *  rubric_text: string
 *  helper_text: string
 *  rubric_audio_id: string
 *  helper_audio_id: string
 *  skill_id: string
 *  level_id: string
 *  task_type_id: string
 *  phase: string
 * }[]>}
 * @see http://dev-dyl-website-docs-f1dd5d50.s3-website.eu-west-2.amazonaws.com/#api-Rubrics-getAllRubrics
 */
export default async function getRubrics(level_id = null) {

    let response = null;
    if (level_id) {
        response = await api.get(`rubrics?level_id=${level_id}`);
    } else {
        response = await api.get(`rubrics`);
    }
    return response?.data;
}